import { HorizontalSpaceBetween } from '@american-autonomy/ag-ui';

import BodyText from 'components/text/BodyText';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const HealthMetricRow: FunctionComponent<Props> = ({
    className = '',
    label,
    testId = TEST_ID,
    value
}) => (
    <HorizontalSpaceBetween className={`${className} ${styles.healthMetricRow}`} testId={testId}>
        <BodyText text={label} />

        <BodyText className={styles.value} text={value} />
    </HorizontalSpaceBetween>
);

export default HealthMetricRow;
